<template>
  <div class="medicalInfoCon">
    <img style="width: 28px; height: 28px; margin-right: 16px;" src="../../assets/lk-store-icon.png" alt="">
    <div class="medicalInfoItem" v-if="storeInfo.name">
      <div class="tipCon">
        <lk-tooltip :content="storeInfo.name === '总部门店'?'总部':storeInfo.name">
          <div class="txt" style="font-size: 18px; line-height: 100%; font-weight: 500;">{{ storeInfo.name === '总部门店'?'总部':storeInfo.name }}</div>
        </lk-tooltip>
      </div>
    </div>
    <div class="medicalInfoItem" v-if=" !isNull && medicalInfo.storeMedListCodg">
      <span class="fontSize">零售药店代码：</span>
      <div class="tipCon" style="margin-top: 1px;">
        <lk-tooltip :content="medicalInfo.storeMedListCodg">
          <span class="txt">{{ medicalInfo.storeMedListCodg }}</span>
        </lk-tooltip>
      </div>
    </div>
    <div class="medicalInfoItem" v-if=" !isNull && medicalInfo.apothecaryMedListCodg">
      <span class="fontSize">医保药师代码：</span>
      <div class="tipCon" style="margin-top: 1px;">
        <lk-tooltip :content="medicalInfo.apothecaryMedListCodg">
          <span class="txt">{{ medicalInfo.apothecaryMedListCodg }}</span>
        </lk-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import mapState from '../../mixins/mapState';

export default {
  name: 'MedicalInfo',
  mixins: [mapState],
  props: {
  },
  watch: {
  },
  computed: {
    isNull() {
      return JSON.stringify(this.medicalInfo) == "{}"
    }
  },
  data() {
    return {
      medicalInfo: {},
    };
  },
  methods: {
  },
  created() {
    this.medicalInfo = this.user.medicalInfo;
  },
  mounted() {
  }
};
</script>

<style lang="less" scoped>
.medicalInfoCon {
  position: absolute;
  top: 5px;
  display: flex;
  align-items: center;
  width: 1200px;
  height: 38px;
  border-radius: 4px;
  flex-wrap: wrap;
  padding: 2px 0 2px 20px;
  .medicalInfoItem{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: 12px;
    .tipCon {
      line-height: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;
      // margin-top: 1px;
      .txt {
        display: block;
        font-size: 12px;
        cursor: pointer;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
  .medicalInfoItem:nth-child(odd) {
    margin-right: 10px;
  }
}
.fontSize {
    // margin-top: -1px;
    font-size: 12px;
    line-height: 100%;
  }
</style>
